import { render, staticRenderFns } from "./AutomacaoProcessosNavegantes.vue?vue&type=template&id=33cefae2&scoped=true"
import script from "./AutomacaoProcessosNavegantes.vue?vue&type=script&lang=js"
export * from "./AutomacaoProcessosNavegantes.vue?vue&type=script&lang=js"
import style0 from "./AutomacaoProcessosNavegantes.vue?vue&type=style&index=0&id=33cefae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cefae2",
  null
  
)

export default component.exports